import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Form, Button, Typography, Row, Col } from "antd";
import FormActions from "../forms/FormActions";
import ChildrenAnimationWrapper from "../animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../animations/AnimationChildWrapper";
import { CloseOutlined } from "@ant-design/icons";
const { Title } = Typography;

const AddEntityForm = (props) => {
  const {
    mode,
    onFinish,
    onFinishFailed,
    onEntityValuesChange,
    onDecline,
    saveLoading,
    items,
    getDynamicItems,
    addText,
    activeEntity,
    resource,
    action,
    twoColumns,
    formLayout,
    padding,
    initialValues,
    style,
  } = props;
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState(true);

  // Use Form.useWatch to monitor all field values
  const formValues = Form.useWatch([], form);

  // Get items - either dynamic or static
  const currentItems =
    getDynamicItems && formValues
      ? getDynamicItems(formValues, form)
      : items || []; // Provide fallback to empty array if both are missing

  // Effect to validate form when values change
  useEffect(() => {
    if (!formValues) return;

    let hasEmptyRequiredFields = false;

    // Check required fields in current items
    currentItems.forEach((item) => {
      if (item.required) {
        const value = formValues[item.name];
        if (value === undefined || value === "") {
          hasEmptyRequiredFields = true;
        }
      }
    });

    setDisabled(hasEmptyRequiredFields);
  }, [formValues, currentItems, form]);

  useEffect(() => {
    if (mode === "edit" || mode === "withInitial") {
      form.setFieldsValue(activeEntity);
    } else if (initialValues) {
      form.setFieldsValue(initialValues);
    }
  }, [activeEntity, form, initialValues, mode]);

  const onSubmit = (values) => {
    onFinish(values);
  };

  const onCancel = () => {
    onDecline();
  };

  const onValuesChange = (changedValues, allValues) => {
    if (onEntityValuesChange) {
      onEntityValuesChange(allValues, form, changedValues);
    }
  };

  const layout = formLayout
    ? formLayout
    : {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
      };

  return (
    <div>
      <div className="header" style={{ height: "40px" }}>
        <Button
          style={{ position: "absolute", left: 10, top: 10 }}
          className="closeBtn"
          type="text"
          shape="circle"
          icon={<CloseOutlined />}
          onClick={onCancel}
        />
      </div>
      <Title
        style={{
          fontSize: "30px",
          fontWeight: 500,
          lineHeight: 1.27,
          color: "rgba(0, 0, 0, 0.85)",
          margin: "13px 0 40px 0 ",
          textAlign: "center",
        }}
      >
        {addText}
      </Title>
      <Form
        {...layout}
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}
        form={form}
        style={
          style
            ? style
            : {
                padding: padding
                  ? padding
                  : twoColumns
                  ? "0 40px"
                  : "0 128px 0px 128px",
                width: twoColumns ? "900px" : "650px",
              }
        }
        onValuesChange={onValuesChange}
      >
        <ChildrenAnimationWrapper>
          <Row>
            {currentItems.map((item, i) => (
              <Col
                key={i}
                span={twoColumns ? 12 : 24}
                style={{ padding: "0 20px" }}
              >
                <AnimationChildWrapper key={i} itemKey={i}>
                  {item.comp}
                </AnimationChildWrapper>
              </Col>
            ))}
            <Row style={{ width: "100%" }}>
              <Col span={24}>
                <FormActions
                  resource={resource}
                  action={action}
                  onCancel={onDecline}
                  hideDelete={true}
                  hideDecline={true}
                  mode={mode}
                  onDecline={onCancel}
                  saveLoading={saveLoading}
                  disabled={disabled || saveLoading}
                />
              </Col>
            </Row>
          </Row>
        </ChildrenAnimationWrapper>
      </Form>
    </div>
  );
};

AddEntityForm.propTypes = {
  mode: PropTypes.string,
  onFinish: PropTypes.func,
  onFinishFailed: PropTypes.func,
  onDecline: PropTypes.func,
  addImage: PropTypes.func,
  saveLoading: PropTypes.bool,
  category: PropTypes.string,
  name: PropTypes.string,
  items: PropTypes.array, // Now optional if getDynamicItems is provided
  getDynamicItems: PropTypes.func,
  activeEntity: PropTypes.object,
  resource: PropTypes.string,
  action: PropTypes.string,
  twoColumns: PropTypes.bool,
};

export default AddEntityForm;
